var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 27.5,
    r: 26.5,
    stroke: "white",
    strokeWidth: 1.24706
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.9471 29.5873V38.7234H24.7503V29.5873H21.2637V25.8827H24.7503V24.5349C24.7503 19.531 26.8406 16.8999 31.2634 16.8999C32.6193 16.8999 32.9583 17.1178 33.7008 17.2954V20.9595C32.8695 20.8143 32.6355 20.7335 31.7719 20.7335C30.7469 20.7335 30.1981 21.0241 29.6977 21.5971C29.1973 22.1702 28.9471 23.1629 28.9471 24.5833V25.8908H33.7008L32.4256 29.5953H28.9471V29.5873Z",
    stroke: "white",
    strokeWidth: 1.24706
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.65ff84f2bf403d699c6c0e8f83178525.svg";
export { ForwardRef as ReactComponent };